/* Mirrors src/hooks/use-breakpoint.ts (Breakpoints.sm=640, Breakpoints.lg=1024)
   and src/constants/theme.ts (Spacing.*, Radius.xl=16) — keep in sync if
   those change. Media queries (not a JS `isLg`) so the static export paints
   the final hero size on first load — see hero-search.module.css.

   The hero used to be full-bleed with aspect-ratio 2, i.e. 960px tall on a
   1920px screen: nothing but photo above the fold, and the 1024px source
   upscaled ~1.9x. It's now boxed inside the content column (like the homepage
   hero) with a capped height. */

/* Raw <nav>/<li>/<button> elements don't get react-native-web's Text font
   (they'd fall back to the browser default: Times, or Arial on buttons), so
   pin the same system stack RNW puts on every <Text>. The <h1> overrides it
   with Fonts.serif inline. */
.hero {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 280px;
  border-radius: 16px;
  overflow: hidden;
}

@media (min-width: 640px) {
  .hero {
    height: 340px;
  }
}

@media (min-width: 1024px) {
  .hero {
    height: clamp(360px, 45vh, 460px);
  }
}

.img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* A light scrim at the top for the breadcrumb, clear through the middle so
   the photo reads, and a strong one at the bottom for the title + chips. */
.shade {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.35) 0%,
    rgba(0, 0, 0, 0) 28%,
    rgba(0, 0, 0, 0) 45%,
    rgba(0, 0, 0, 0.78) 100%
  );
}

.crumbs {
  position: relative;
  margin: 0;
  padding: 14px 16px 0;
}

.crumbList {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.crumbSep {
  opacity: 0.7;
}

.content {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
}

@media (min-width: 1024px) {
  .crumbs {
    padding: 20px 28px 0;
  }

  .content {
    gap: 18px;
    padding: 28px;
  }
}

.title {
  margin: 0;
  color: #fff;
  font-weight: 700;
  font-size: 34px;
  line-height: 40px;
  text-shadow: 0 1px 12px rgba(0, 0, 0, 0.35);
}

@media (min-width: 640px) {
  .title {
    font-size: 44px;
    line-height: 50px;
  }
}

@media (min-width: 1024px) {
  .title {
    font-size: 56px;
    line-height: 62px;
  }
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  color: #fff;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.chip:hover {
  background: rgba(255, 255, 255, 0.28);
}

.chip:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}
